import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import VoiceWavePlayer from "./VoiceRecorder/VoiceWavePlayer";
import attachmentIcon from "../../assets/attachment.svg";
import { fileExtension, formatBytes } from "./attachmentUpload";
import "./CommentAttachments.css";

/**
 * Вложения комментария по типам: голосовые — плеер, картинки — миниатюры с просмотром,
 * файлы — плашка с именем и размером (открывается по ссылке CDN).
 * Клики не всплывают к карточке, чтобы не дёргать перемотку видео.
 */
const CommentAttachments = ({ attachments }) => {
  const { t } = useTranslation();
  const [lightbox, setLightbox] = useState(null);

  useEffect(() => {
    if (!lightbox) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") setLightbox(null);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [lightbox]);

  if (!attachments || !attachments.length) return null;

  const voices = attachments.filter((a) => a.type === "VOICE");
  const images = attachments.filter((a) => a.type === "IMAGE");
  const files = attachments.filter((a) => a.type !== "VOICE" && a.type !== "IMAGE");

  const stop = (e) => e.stopPropagation();

  return (
    <div className="catt" onClick={stop}>
      {voices.map((a) => (
        <div key={a.id || a.mediaId} style={{ width: "100%" }}>
          <VoiceWavePlayer className="comment-voice-message" src={a.cdnUrl} />
        </div>
      ))}

      {images.length > 0 && (
        <div className="catt-images">
          {images.map((a) => (
            <button
              key={a.id || a.mediaId}
              type="button"
              className="catt-image"
              onClick={() => setLightbox(a)}
              title={a.fileName || t("comments.attach.image")}
            >
              <img src={a.cdnUrl} alt={a.fileName || ""} loading="lazy" />
            </button>
          ))}
        </div>
      )}

      {files.length > 0 && (
        <div className="catt-files">
          {files.map((a) => {
            const name = a.fileName || `${t("comments.attach.file")}.${fileExtension(a.cdnUrl?.split("?")[0]) || "txt"}`;
            return (
              <a
                key={a.id || a.mediaId}
                className="catt-file"
                href={a.cdnUrl}
                target="_blank"
                rel="noopener noreferrer"
                download={a.fileName || true}
                title={name}
              >
                <img src={attachmentIcon} alt="" className="catt-file-icon" />
                <span className="catt-file-name">{name}</span>
                {a.sizeBytes ? (
                  <span className="catt-file-size">{formatBytes(a.sizeBytes)}</span>
                ) : null}
              </a>
            );
          })}
        </div>
      )}

      {lightbox &&
        createPortal(
          <div className="catt-lightbox" onClick={() => setLightbox(null)}>
            <img
              src={lightbox.cdnUrl}
              alt={lightbox.fileName || ""}
              onClick={(e) => e.stopPropagation()}
            />
            <div className="catt-lightbox-bar" onClick={(e) => e.stopPropagation()}>
              <span className="catt-lightbox-name">{lightbox.fileName || ""}</span>
              <a
                className="catt-lightbox-link"
                href={lightbox.cdnUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("comments.attach.open")}
              </a>
              <button
                type="button"
                className="catt-lightbox-close"
                onClick={() => setLightbox(null)}
              >
                ×
              </button>
            </div>
          </div>,
          document.body
        )}
    </div>
  );
};

export default CommentAttachments;
